export default __webpack_public_path__ + "static/media/Snd3.e2e0c566.mp3";